document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initContador();
});

function initReveal() {
  var els = document.querySelectorAll('.bf-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof IntersectionObserver === 'undefined') return;

  els.forEach(function (el, i) {
    el.style.transitionDelay = (i % 6) * 80 + 'ms';
    var rect = el.getBoundingClientRect();
    var enPantalla = rect.top < window.innerHeight && rect.bottom > 0;
    if (!enPantalla) el.classList.add('bf-hidden');
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('bf-hidden');
          entry.target.classList.add('bf-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: si algo impide que el observador dispare, todo se muestra igualmente.
  setTimeout(function () {
    document.querySelectorAll('.bf-reveal.bf-hidden').forEach(function (el) {
      el.classList.remove('bf-hidden');
      el.classList.add('bf-visible');
    });
  }, 4000);
}

function initGaleria() {
  document.querySelectorAll('.bf-galeria').forEach(function (galeria) {
    var principal = galeria.querySelector('.bf-galeria__principal img');
    var minis = galeria.querySelectorAll('.bf-galeria__miniatura');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var url = mini.getAttribute('data-full');
        if (!url) return;
        principal.src = url;
        minis.forEach(function (m) { m.classList.remove('is-active'); });
        mini.classList.add('is-active');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('.bf-compra').forEach(function (compra) {
    var dataEl = compra.querySelector('[data-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = compra.querySelector('input[name="id"]');
    var precioActual = compra.querySelector('.bf-compra__precio-actual');
    var precioAnterior = compra.querySelector('.bf-compra__precio-anterior');
    var btnComprar = compra.querySelector('.bf-btn--comprar');
    var stockAviso = compra.querySelector('.bf-compra__stock');
    var grupos = compra.querySelectorAll('.bf-opcion');

    function opcionesSeleccionadas() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.bf-swatch.is-selected');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function formatearPrecio(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatearPrecio(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatearPrecio(variante.compare_at_price);
          precioAnterior.style.display = '';
        } else {
          precioAnterior.style.display = 'none';
        }
      }
      if (btnComprar) {
        btnComprar.disabled = !variante.available;
        btnComprar.textContent = variante.available
          ? btnComprar.getAttribute('data-texto-disponible')
          : btnComprar.getAttribute('data-texto-agotado');
      }
      if (stockAviso) {
        stockAviso.style.display = variante.available ? 'none' : 'block';
      }
    }

    grupos.forEach(function (grupo) {
      grupo.querySelectorAll('.bf-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.disabled) return;
          grupo.querySelectorAll('.bf-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initContador() {
  document.querySelectorAll('.bf-cta__stat-num[data-hasta]').forEach(function (el) {
    var hasta = parseInt(el.getAttribute('data-hasta'), 10);
    if (!hasta) return;
    var animado = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animado) {
          animado = true;
          var inicio = 0;
          var duracion = 1200;
          var t0 = performance.now();
          function paso(t) {
            var progreso = Math.min((t - t0) / duracion, 1);
            el.textContent = Math.floor(progreso * hasta).toLocaleString('es');
            if (progreso < 1) requestAnimationFrame(paso);
            else el.textContent = hasta.toLocaleString('es');
          }
          requestAnimationFrame(paso);
        }
      });
    }, { threshold: 0.4 });
    observer.observe(el);
  });
}
